import { AxiosError } from 'axios';

export function isAxiosError(error: unknown): error is AxiosError {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return !!error?.isAxiosError;
}
